import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";
import cadeaux from "images/cadeaux.png";
import catalogue from "images/catalogue.png";
import electromenager from "images/electromenager.png";
import electro from "images/electro.png";
import montre from "images/montre.png";
import produits from "images/produits.png";
import parfum from "images/parfum.png";
import shoes from "images/shoes.png";
import tshirt from "images/t-shirt.png";
import accessoire from "images/accessoire.png";
import construction from "images/construction.png";
import miel from "images/miel.png";

const Section = tw.section`max-w-screen-xl mx-auto px-4 md:px-8 py-12 md:py-16`;
const Heading = tw.h2`text-2xl md:text-3xl font-extrabold text-center text-[#133b8c]`;
const Sub = tw.p`mt-2 text-sm md:text-base text-center text-gray-500`;

const Grid = styled.div`
  ${tw`mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6`}
`;

const Card = styled.a`
  ${tw`flex flex-col items-center text-center no-underline`}
`;

const Circle = styled.div`
  ${tw`h-20 w-20 md:h-24 md:w-24 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden`}
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
`;

const Img = styled.img`
  ${tw`object-cover`}
  width: 100%;
  height: 100%;
`;

const Label = tw.span`mt-3 text-xs md:text-sm font-medium text-gray-700`;
// Map category translation keys to images
const categoryItems = [
  { key: "Cadeaux", img: cadeaux, href: "/cadeaux" },
  { key: "Librairie_Papeterie", img: catalogue, href: "/librairie-papeterie" },
  { key: "Electromenager", img: electromenager, href: "/electromenager" },
  { key: "Accessoires_Telephone", img: accessoire, href: "/accessoires-telephone" },
  { key: "Montres", img: montre, href: "/montres" },
  { key: "Cosmetiques_Complements", img: produits, href: "/cosmetiques-complements" },
  { key: "Parfums", img: parfum, href: "/parfums" },
  { key: "Chaussures", img: shoes, href: "/chaussures" },
  { key: "Textile_Habillement", img: tshirt, href: "/textile-habillement" },
  { key: "Bijoux", img: accessoire, href: "/bijoux" },
  { key: "Materiaux_Construction", img: construction, href: "/materiaux-construction" },
  { key: "Produits_Naturels", img: miel, href: "/produits-naturels" },
];

const OurPicks = () => {
  const { t } = useTranslation();
  return (
    <Section>
      <Heading>{t("picks.heading", "Our Picks for You")}</Heading>
      <Sub>{t("picks.subtitle", "Our products are designed for everyone")}</Sub>
      <Grid>
        {categoryItems.map(({ key, img, href }) => (
          <Card key={key} href={href} aria-label={t(`categories_menu.${key}`)}>
            <Circle>
              <Img src={img} alt={t(`categories_menu.${key}`)} />
            </Circle>
            <Label>{t(`categories_menu.${key}`)}</Label>
          </Card>
        ))}
      </Grid>
    </Section>
  );
};

export default OurPicks;
